import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CoreService } from '../services/core.service';


@Injectable({
  providedIn: 'root',
})
export abstract class ApiService {
  protected apiFrontUrl = '';
  protected http = inject(HttpClient);
  protected coreService = inject(CoreService);

  constructor() {
    if (this.coreService.isBrowser()) {
      this.apiFrontUrl = environment.api.public + '/front';

    } else {
      this.apiFrontUrl = environment.api.ssr + '/front';
    }
  }

  cacheUid() {
    return Date.now();
    // return moment().utc().startOf('hour').unix();
  }
}
